import { PurchaseBillDetailDto } from 'src/dtos/purchaseBill/purchaseBillDto';
import { formatDate } from 'src/utils/string/stringUtil';

export interface PUR2040_R01Dto extends PurchaseBillDetailDto {
    // 검색 조건만 추가 (4개)
    startDate: string | null;
    endDate: string | null;
    listLength: number | null;
    refetchListLength: number | null;
    
    // 화면 표시용 추가 필드 (2개)
    compNm: string;
    unitNm: string;
    locationCd?: string;
    locationNm?: string;
}

export type GridRowData = PUR2040_R01Dto;

export const defaultPUR2040_R01Dto: PUR2040_R01Dto = {
    // BaseDto 기본값 (필수)
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    
    // PUR2040_R01 추가 필드만 정의 (6개)
    startDate: null,
    endDate: null,
    listLength: null,
    refetchListLength: null,
    compNm: '',
    unitNm: '',
    locationCd: '',
    locationNm: '',
    
    // PurchaseBillDetailDto 상속 필드들 (13개)
    purchaseBillNo: '',
    itemNo: '',
    itemCd: '',
    itemNm: '',
    itemSpec: '',
    modelNo: '',
    compCd: '',
    purchaseDt: formatDate(new Date()),
    customCd: '',
    customNm: '',
    itemSeq: 0,
    billUnit: '',
    billQty: 0,
    billPrice: 0,
    dcAmt: 0,
    billAmt: 0,
    transportItemNo: '',
    remark: '',
    inserted: false,
    isModified: false,
};
